<template>

    <div class="modalTabWindow">
        <section class="mainSubnav">
            <nav>
                <a :class="{active:activeTab=='activeTab1'}" @click="activeTab='activeTab1'">Consortium</a>
                <a :class="{active:activeTab=='activeTab2'}" @click="activeTab='activeTab2'">Contacten</a>
            </nav>
        </section>

        <div class="tabContainer" :class="activeTab">

            <div class="defaultTab tab1"> 
                    <TabConsortium :consortium="consortium"  v-if="consortium"/>
            </div>

            <div class="defaultTab tab2">
                    <TabContacts :contacts="consortium.Contacts"  v-if="consortium"/>
            </div>
            
        </div>
    </div>
</template>

<script>
import TabConsortium from './TabConsortium.vue';
import TabContacts from './TabContacts.vue';
import TabUsecase from './TabUsecase.vue';
export default {
    components: {
        TabConsortium,
        TabContacts,
        TabUsecase
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            activeTab: 'activeTab1',
            consortium: null
        }
    },
    methods: {
        async loadData() {
            const res = await this.callApi('get', `/consortiums/details/${this.data.consortium_id}`);
            this.consortium = res.data.result;
        }
    },
    mounted() {
        console.log(this.data);
        this.loadData()
    }
}
</script>

